// eslint-disable-next-line import/no-cycle
import RwAdvisorService from '@advisor/rwSdk/AdvisorService';
import Aum from '@advisor/models/store/aum/index';
import exceptionHandler from '@advisor/util/exceptionHandler';
import {addRiaComponentTo} from '@advisor/util/store/paramInjects';

export const stateObj = function () {
  return new Aum();
};

export const actions = {
  async getAll({rootState, commit}, payload) {
    try {
      const fullPayload = addRiaComponentTo({...payload, clientFilter: payload.filter}, rootState.settings.default);
      const sdkResponse = await RwAdvisorService.getAdvisorAumTrends(fullPayload).catch((error) => {
        throw error;
      });

      return commit('SET_ALL', sdkResponse);
    } catch (error) {
      return exceptionHandler.handleGenericException('aum.getAll', error, true);
    }
  },
};

export const mutations = {
  SET_ALL(state, payload) {
    state.dailyAums = payload.dailyAums;
    state.endingAumDate = payload.endingAumDate;
    state.percentDecrease = payload.percentDecrease;
    state.percentIncrease = payload.percentIncrease;
    state.startingAumDate = payload.startingAumDate;
    state.endDateTotalRiaAum = payload.endDateTotalRiaAum;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
  mutations,
};
